const translationsReducer = (state = {}, action) => {
  switch (action.type) {
    case 'UPDATE_TRANSLATIONS':
      return action.translations;
    default:
      break;
  }
  return state;
}

export default translationsReducer;